import * as React from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { Box } from "@mui/material";
import { RaRecord } from "ra-core";
import { ExcludeProps, MyField } from "./types";
import omit from "lodash/omit";

export interface MyCreateProp<RecordType extends RaRecord = any>
  extends CreateProps<RecordType> {
  fields: MyField<RecordType>[];
  maxWidth?: number | string;
}

const MyCreate = (props: MyCreateProp) => {
  const { fields, maxWidth = "100%", ...rest } = props;

  return (
    <Create {...rest}>
      <SimpleForm sx={{ maxWidth: maxWidth }}>
        {fields
          .filter((f) => f.isCreate && f.editComponent)
          .map((field: MyField, index) => {
            const {
              editComponent: FieldComponent,
              source,
              label,
              editProps,
            } = field;

            if (!FieldComponent) {
              return <></>;
            }

            const curProps = {
              ...editProps,
            };

            if (FieldComponent === Box) {
              return (
                <FieldComponent
                  key={`${index}`}
                  {...omit(curProps, ExcludeProps)}
                />
              );
            } else {
            }

            return (
              <FieldComponent
                key={`${index}`}
                source={source}
                label={label}
                {...omit(curProps, ["minWidth", "maxWidth"])}
              />
            );
          })}
      </SimpleForm>
    </Create>
  );
};

export default MyCreate;
